import { Divider, Drawer, Form, Radio, Input, Space, Button } from 'antd';
import SiteModuleDrawerOperationLogExtra from '../SiteModuleDrawerOperationLogExtra';
import { drawerWidth, fullWidthPageFormItemLayout } from '@utils/property';
import { useState, useEffect, Fragment } from 'react';

export default ({ drawerState, setDrawerState, currentModule, updateModuleSettings }) => {
    const [form] = Form.useForm();

    const closeDrawer = () => setDrawerState({ ...drawerState, visible: false });

    // 新增模块
    const onFinish = async values => {
        updateModuleSettings({
            ...values,
            id: currentModule.id,
        });
    };

    useEffect(() => {
        if (currentModule && drawerState?.visible) {
            form.setFieldsValue({
                displayTitle: currentModule.displayTitle,
                displayTitleEn: currentModule.displayTitleEn,
                hiddenWeb: currentModule.hiddenWeb,
                hiddenH5: currentModule.hiddenH5,
                status: currentModule.status,
                url: currentModule.url,
            });
        }
    }, [currentModule, drawerState]);

    return (
        <Drawer
            closable={{ placement: 'end' }}
            title={`模块配置：${currentModule?.displayTitle}`}
            className="applog-record-drawer"
            size="100%"
            placement="bottom"
            push={false}
            open={drawerState?.moduleType === 22 && drawerState.visible}
            onClose={closeDrawer}
            footer={
                <div className="custom-drawer-footer" style={{ textAlign: 'right' }}>
                    <Space>
                        <Button onClick={closeDrawer}>取消</Button>
                        <Button type="primary" form="MyprojectsModuleForm" htmlType="submit">
                            确定
                        </Button>
                    </Space>
                </div>
            }
        >
            <SiteModuleDrawerOperationLogExtra siteModuleId={currentModule?.id} />
            <Form name="MyprojectsModuleForm" form={form} onFinish={onFinish} {...fullWidthPageFormItemLayout}>
                <Form.Item name="displayTitle" label="显示标题" rules={[{ required: true, message: '显示标题不能为空' }]}>
                    <Input placeholder="请输入模块显示标题" />
                </Form.Item>

                <Form.Item name="displayTitleEn" label="英文显示标题">
                    <Input placeholder="请输入模块英文显示标题" />
                </Form.Item>
                {/* <Form.Item
                    name="url"
                    label="外部链接"
                >
                    <Input placeholder="请输入外部链接" />
                </Form.Item> */}
                <Form.Item
                    name="status"
                    label="导航状态"
                    rules={[
                        {
                            required: true,
                        },
                    ]}
                >
                    <Radio.Group>
                        <Radio value={1}>开启</Radio>
                        <Radio value={2}>敬请期待</Radio>
                    </Radio.Group>
                </Form.Item>
                <Form.Item name="hiddenWeb" label="Web端是否隐藏" rules={[{ required: true }]}>
                    <Radio.Group>
                        <Radio value={0}>显示</Radio>
                        <Radio value={1}>隐藏</Radio>
                    </Radio.Group>
                </Form.Item>

                <Form.Item name="hiddenH5" label="H5端是否隐藏" rules={[{ required: true }]}>
                    <Radio.Group>
                        <Radio value={0}>显示</Radio>
                        <Radio value={1}>隐藏</Radio>
                    </Radio.Group>
                </Form.Item>
            </Form>
        </Drawer>
    );
};
